import React, { useState, useEffect } from "react";
import "./Brands.css";
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from "react-router-dom";
import { Button, Navbar, Nav, Container, Row, Col, Card, Table, Form, Dropdown } from "react-bootstrap";
// import dash from "../src/Photos/Dashboard.png";
// import menu from "../src/Photos/Menu.png";
// import { IoIosArrowForward } from "react-icons/io";
import Account from "../src/Photos/Account.png";
import Logo from "../src/Photos/eximtracfinallogo.png";

// import { FaRegEye } from "react-icons/fa";
// import { FaTrashAlt } from "react-icons/fa";
// import { LuPencil } from "react-icons/lu";

import { hasAccess } from "../src/roleAccess.js";

function Brands() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    // const [toggled, setToggled] = React.useState(false);



    // const [showModal, setShowModal] = useState(false);
    // const [file, setFile] = useState(null); // State to hold the uploaded file
    // const [successMessage, setSuccessMessage] = useState(false);

    // // Show/Hide Modal
    // const handleShowModal = () => setShowModal(true);
    // const handleCloseModal = () => setShowModal(false);

    // // Handle file input
    // const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    // };

    // // Function to handle the file upload and show success message
    // const handleAddCategory = () => {
    //     if (file) {
    //         console.log('File uploaded:', file);
    //         setSuccessMessage(true);  // Show success message
    //         setTimeout(() => setSuccessMessage(false), 3000);  // Hide message after 3 seconds
    //         setShowModal(false);  // Close the modal
    //     }
    // };





    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState("");

    // Handle file selection
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    // Handle file upload to the backend
    const handleFileUpload = async (event) => {
        event.preventDefault();
        if (!file) {
            setUploadStatus("Please select a CSV file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            // const token = localStorage.getItem("adminToken");
            const response = await fetch("https://api-ft5g.onrender.com/upload-csv", {
                method: "POST",
                body: formData,
                // "Authorization": `Bearer ${token}`,
            });

            if (response.ok) {
                setUploadStatus("File uploaded successfully!");
            } else {
                const errorResponse = await response.json();
                setUploadStatus(`Upload failed: ${errorResponse.message}`);
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setUploadStatus("An error occurred while uploading the file.");
        }
    };




    const [input, setData] = useState([]); // Ensure `input` starts as an empty array

    useEffect(() => {
        const fetchBrands = async () => {
            const token = localStorage.getItem("adminToken"); // or "adminToken" if you're using that

            if (!token) {
                console.warn("Token not found. Please login.");
                return;
            }

            try {
                const res = await fetch('https://api-ft5g.onrender.com/GetBrand', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!res.ok) {
                    throw new Error(`Failed to fetch brands. Status: ${res.status}`);
                }

                const docs = await res.json();

                if (docs && docs.data) {
                    setData(docs.data);
                    console.log(docs.data);
                } else {
                    console.warn("Data property not found in response:", docs);
                    setData([]);
                }
            } catch (error) {
                console.error("Error fetching brand data:", error);
                setData([]);
            }
        };

        fetchBrands();
    }, []);



    const [editBrand, seteditBrand] = useState({ oldName: "", newName: "" }); // Stores data for editing

    // Handle edit category input change
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        seteditBrand((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle edit button click
    const handleEditClick = (categoryName) => {
        seteditBrand({ oldName: categoryName, newName: categoryName });
    };

    // Handle update category
    const handleUpdateBrand = (e) => {
        e.preventDefault();

        if (editBrand.oldName === editBrand.newName) {
            alert('No changes made to Brand name.');
            return;
        }

        // Send PUT request to update category
        // const token = localStorage.getItem("adminToken");
        fetch('https://api-ft5g.onrender.com/update-brand', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(editBrand)
        })
            .then(response => response.json())
            .then(data => {
                alert(data.message);
                // Update the local categories list
                setData((prevBrand) =>
                    prevBrand.map((brand) =>
                        brand.name === editBrand.oldName
                            ? { ...brand, name: editBrand.newName }
                            : brand
                    )
                );
            })
            .catch(error => {
                console.error('Error updating Brand:', error);
                alert('Failed to update Brand');
            });
    };


    //For Image Upload
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [ImageuploadStatus, setImageUploadStatus] = useState("");

    const handleImageFileChange = (event) => {
        setSelectedFiles(event.target.files);
    };

    const handleUpload = async () => {
        if (selectedFiles.length === 0) {
            alert("Please select images to upload.");
            return;
        }

        const formData = new FormData();

        // Append all selected files
        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append("images", selectedFiles[i]);
        }

        try {
            // const token = localStorage.getItem("adminToken");
            const response = await fetch("https://api-ft5g.onrender.com/upload-images", {
                method: "POST",
                body: formData,
                // "Authorization": `Bearer ${token}`,
            });

            const data = await response.json();

            if (response.ok) {
                setImageUploadStatus("Images uploaded successfully!");
            } else {
                setImageUploadStatus(`Error: ${data.error}`);
            }
        } catch (error) {
            console.error("Upload failed:", error);
            setImageUploadStatus("Failed to upload images.");
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };


    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Brands Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <Container className="mt-3">
                <Row>
                    <Col>
                        <Card>
                            <Row className="p-3">
                                <Col lg={7}>
                                    <p className="brand">Brands</p>
                                </Col>

                                {/* Success message */}
                                {/* {successMessage && (
                                    <Alert variant="success" className="text-center">
                                        CSV Uploaded Successfully!
                                    </Alert>
                                )} */}

                                <Col lg={5} className="">
                                    {/* <Button className="brandaddnewcatebtn" onClick={handleShowModal}>
                                        <Link className="brandaddnewcatelink"> */}
                                    <Form onSubmit={handleFileUpload}>
                                        <Form.Label htmlFor="csvFile" className="brandaddnewcatebtn">
                                            Add New Products Select a CSV File:
                                        </Form.Label>
                                        <input
                                            type="file"
                                            id="csvFile"
                                            accept=".csv"
                                            onChange={handleFileChange}
                                        />
                                        <Button type="submit" className="uploadbtn">
                                            Upload
                                        </Button>
                                    </Form>
                                    {uploadStatus && <p>{uploadStatus}</p>}
                                    {/* </Link>
                                    </Button> */}
                                </Col>
                            </Row>

                            {/* Modal for uploading CSV */}
                            {/* <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Upload Complete CSV</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formFile">
                                            <Form.Label>Upload CSV</Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept=".csv"
                                                onChange={handleFileChange}  // File input handler
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="success" onClick={handleAddCategory}>
                                        Add
                                    </Button>
                                </Modal.Footer>
                            </Modal> */}



                            {/* Edit brand modal */}
                            {editBrand.oldName && (
                                <div className="px-3 mb-4">
                                    <h4>Edit Brand</h4>
                                    <form onSubmit={handleUpdateBrand}>
                                        <div>
                                            <label>
                                                Old Brand Name:
                                                <input
                                                    type="text"
                                                    value={editBrand.oldName}
                                                    disabled
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                New Brand Name:
                                                <input
                                                    type="text"
                                                    name="newName"
                                                    value={editBrand.newName}
                                                    onChange={handleEditChange}
                                                    required
                                                    className="mt-3 mx-2"
                                                />
                                            </label>
                                        </div>
                                        <div>
                                            <Button type="submit" variant="success" className="mt-3">Update</Button>
                                        </div>
                                    </form>
                                </div>
                            )}

                            <Row>
                                <Col>
                                    <div className="upload-container">
                                        <h4>Upload Product Images</h4>
                                        <input type="file" multiple onChange={handleImageFileChange} />

                                        <Row>
                                            <Col className="mt-3">
                                                <Button onClick={handleUpload} className="upload-button">Upload Images</Button>
                                            </Col>
                                        </Row>
                                        {ImageuploadStatus && <p className="status-message">{ImageuploadStatus}</p>}
                                    </div>
                                </Col>
                            </Row>


                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Sr.No.</th>
                                        <th>Brand Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        input.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.BRAND}</td>
                                                <td>
                                                    <Button variant="success" onClick={() => handleEditClick(item.BRAND)}>
                                                        Edit
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    {/* <td>
                                                <Row>
                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandviewbtn">
                                                            <Link className="brandviewlink">
                                                                <FaRegEye />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandbinbtn">
                                                            <Link className="brandbinlink">
                                                                <FaTrashAlt />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandpenbtn">
                                                            <Link className="brandpenlink">
                                                                <LuPencil />
                                                            </Link>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </td> */}
                                    {/* </tr> */}

                                    {/* <tr>
                                            <td>2</td>
                                            <td>Brand Name</td> */}
                                    {/* <td>
                                                <Row>
                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandviewbtn">
                                                            <Link className="brandviewlink">
                                                                <FaRegEye />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandbinbtn">
                                                            <Link className="brandbinlink">
                                                                <FaTrashAlt />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandpenbtn">
                                                            <Link className="brandpenlink">
                                                                <LuPencil />
                                                            </Link>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </td> */}
                                    {/* </tr> */}

                                    {/* <tr>
                                            <td>3</td>
                                            <td>Brand Name</td> */}
                                    {/* <td>
                                                <Row>
                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandviewbtn">
                                                            <Link className="brandviewlink">
                                                                <FaRegEye />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandbinbtn">
                                                            <Link className="brandbinlink">
                                                                <FaTrashAlt />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandpenbtn">
                                                            <Link className="brandpenlink">
                                                                <LuPencil />
                                                            </Link>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </td> */}
                                    {/* </tr> */}

                                    {/* <tr>
                                            <td>4</td>
                                            <td>Brand Name</td> */}
                                    {/* <td>
                                                <Row>
                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandviewbtn">
                                                            <Link className="brandviewlink">
                                                                <FaRegEye />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandbinbtn">
                                                            <Link className="brandbinlink">
                                                                <FaTrashAlt />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandpenbtn">
                                                            <Link className="brandpenlink">
                                                                <LuPencil />
                                                            </Link>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </td> */}
                                    {/* </tr> */}

                                    {/* <tr>
                                            <td>5</td>
                                            <td>Brand Name</td> */}
                                    {/* <td>
                                                <Row>
                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandviewbtn">
                                                            <Link className="brandviewlink">
                                                                <FaRegEye />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandbinbtn">
                                                            <Link className="brandbinlink">
                                                                <FaTrashAlt />
                                                            </Link>
                                                        </Button>
                                                    </Col>

                                                    <Col lg={1} xs={4}>
                                                        <Button className="brandpenbtn">
                                                            <Link className="brandpenlink">
                                                                <LuPencil />
                                                            </Link>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </td> */}
                                    {/* </tr> */}
                                </tbody>
                            </Table>
                        </Card>
                    </Col >
                </Row >
            </Container >
            {/* </div > */}
        </>
    );
}

export default Brands;